import React from "react";
import {
  SimpleGrid,
  Box,
  Image,
  VStack,
  Text,
  Button,
  Container,
  Stack,
  ListItem,
  Link,
  UnorderedList,
  useDisclosure,
} from "@chakra-ui/react";
import headerImage from "../Img/headerImage.png";
import HomeImage from "../Img/homeImage.png";
import Form from "./Form";

const About = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <SimpleGrid backgroundColor={"#000"}>
        {/* 1 */}
        <SimpleGrid
          columns={[1, 2]}
          textAlign={["center", "right"]}
          spacing={[0, 0]}
          mt={10}
        >
          <Box height={["100%", "100%", "300px", "350px", "500px"]}>
            <Container maxW="container.sm">
              <VStack
                height={["100%", "400px"]}
                mt={10}
                spacing={4}
                align="stretch"
                // border={"1px solid yellow"}
                w={["100%", "50vw"]}
              >
                <Box>
                  <Text
                    fontSize={["50px", "50px", "40px", "45px", "80px"]}
                    fontWeight={"1000"}
                  >
                    شمروخ للإتصالات
                  </Text>
                </Box>
                <Box fontSize={["40px", "40px", "30px", "25px", "5xl"]}>
                  <Text mt={1}>تقسيط جميع الجوالات</Text>
                  <Text> بدون دفعة أولى و التسليم فوري</Text>
                </Box>
                <Box mt={10}>
                  <Stack direction={["column", "row"]} spacing="24px">
                    <Box>
                      <Link href="#Conditions">
                        <Button
                          colorScheme="orange"
                          variant="outline"
                          w={["55vw", "23vw"]}
                        >
                          الشروط
                        </Button>
                      </Link>
                    </Box>
                    <Box>
                      <Button
                        onClick={onOpen}
                        colorScheme="teal"
                        variant="outline"
                        w={["55vw", "23vw"]}
                      >
                        اطلب الان
                      </Button>
                    </Box>
                  </Stack>
                </Box>
              </VStack>
            </Container>
          </Box>
          <Box
            height={["100%", "100%", "300px", "350px", "500px"]}
            mt={["50px", 0]}
          >
            <Container maxW="container.sm">
              <Image src={headerImage} />
            </Container>
          </Box>
        </SimpleGrid>
        {/* 2 */}
        <SimpleGrid columns={[1, 2]} spacing={0} id={"Conditions"}>
          <Box height={["100%", "600px"]}>
            <Box
              border={"1px solid "}
              borderRadius={10}
              height={["90%", "500px"]}
              m={10}
              p={10}
            >
              <Stack spacing={8}>
                <Text
                  fontSize={["2xl", "2xl", "1xl", "3xl"]}
                  color={"#00B2F8"}
                  as={"b"}
                >
                  شروط الحصول على تقسيط
                </Text>
                <Text fontSize={["1xl", "1xl", "1xl", "2xl"]}>
                  <UnorderedList>
                    <ListItem>موظف القطاع الحكومي والخاص:</ListItem>
                    <UnorderedList>
                      <ListItem>القطاع الحكومي ٤٠٠٠ كحد ادنى</ListItem>
                      <ListItem>
                        القطاع الخاص ٤٠٠٠ كحد ادنى ومدة التوظيف لا تقل عن اربعة
                        اشهر
                      </ListItem>
                      <ListItem>الهويه الوطنية الاصل او توكلنا</ListItem>
                      <ListItem>ايميل</ListItem>
                      <ListItem>الافصاح عن القروض</ListItem>
                    </UnorderedList>
                  </UnorderedList>
                </Text>
              </Stack>
            </Box>
          </Box>
          <Box height={["100%", "600px"]}>
            <Box
              border={"1px solid "}
              borderRadius={10}
              height={["90%", "500px"]}
              m={10}
              p={10}
            >
              <Stack spacing={4}>
                <Text
                  fontSize={["2xl", "2xl", "1xl", "3xl"]}
                  color={"#00B2F8"}
                  as={"b"}
                >
                  {" "}
                  سيتم رفض الطلب مباشرة في الحالات التالية{" "}
                </Text>
                <Text fontSize={["1xl", "1xl", "1xl", "2xl"]}>
                  <UnorderedList>
                    <ListItem>
                      في وجود متعثرات في سمة باستثناء فواتير الاتصالات
                    </ListItem>
                    <ListItem>في حال وجود ايقاف خدمات</ListItem>
                  </UnorderedList>
                </Text>

                <Box>
                  <Text
                    fontSize={["2xl", "2xl", "1xl", "3xl"]}
                    color={"#FF8400"}
                  >
                    ملاحظة
                  </Text>
                  <Text fontSize={["1xl", "1xl", "1xl", "2xl"]}>
                    <UnorderedList>
                      <ListItem>الرياض فقط</ListItem>
                      <ListItem>الدوام من ٤ مساء الى ١٠ مساء </ListItem>
                      <ListItem> الجمعه اجازة</ListItem>
                      <ListItem color={"#FC4E21"}>
                        الرجاء عدم ارسال اوراق ثبوتية او بطاقات رسميه
                      </ListItem>
                    </UnorderedList>
                  </Text>
                </Box>
              </Stack>
            </Box>
          </Box>
        </SimpleGrid>
        {/* 3 */}
        <SimpleGrid columns={[1, 2]} spacing={[0, 0, 0, 20]}>
          <Box
            height={["100%", "90%", "390px", "550px", "590px"]}
            paddingRight={[2, null, 10, null, 150]}
          >
            <Box
              overflow={"hidden"}
              height={[300, 200, 340, 500]}
              width={[330, 330, 300, 500]}
              mt={[0, 5]}
            >
              <Image src="homeImage.png" fallbackSrc={HomeImage} />
            </Box>
          </Box>
          <Box
            height={["100%", "90%", "390px", "550px", "590px"]}
            paddingRight={[8, 0]}
          >
            <Box height={[350, 500]} width={[330, 330, 300, 500]} mt={[0, 5]}>
              <Text fontSize={["6xl", "6xl", "6xl", "90px"]} as={"b"}>
                iPhone 14
                <br />
                بالـتقسيط
                <br />و بـــــــــــــــدون دفـعـة أولـى
              </Text>
            </Box>
          </Box>
        </SimpleGrid>
      </SimpleGrid>
      {/* Modal */}
      <Form isOpen={isOpen} onClose={onClose} />
    </>
  );
};

export default About;
